import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  FormLayout,
  Heading,
  HorizontalRule,
  Paragraph,
  Section,
  IconStatusErrorOnlight,
  withTrackPage,
} from '@piggybank/core';

import styles from './error-page.module.css';
import { isButtonVisible } from './errorPageFunctions';

import getEnvironment from '~/lib/environment';

import nls from './nls/ErrorPage';
import { createTranslator } from '~/lib/nls-helper';

const environment = getEnvironment();
const NLS = createTranslator(nls);

const ErrorPage = ({ globalData: { ismobile } = {} } = {}) => (
  <FormLayout>
    <Section>
      <div className={styles.Scarlet}>
        <IconStatusErrorOnlight width="3em" />
      </div>
      <Heading level={1}>{NLS`Something went wrong`}</Heading>
      <Paragraph lead>
        {NLS`We are currently having some technical difficulties. Please try again in a few minutes.`}
      </Paragraph>
      <HorizontalRule />
    </Section>
    <Section>
      <Heading accentBar level={2}>
        {NLS`More information`}
      </Heading>
      <Paragraph marginBottom={5}>
        {NLS`If this message appears while you were confirming your offer and you have doubts about whether the process was concluded, we recommend checking your email as you will receive the complete application notification.`}
      </Paragraph>
      <Paragraph marginBottom={5}>
        {NLS`If you do not receive an email, do not worry, your request was probably not completed. You can check it by visiting again the offers you have available to know if it is still showing.`}
      </Paragraph>
      <Paragraph marginBottom={5}>
        {NLS`The email to which you receive the confirmation of an offer is the one you have registered with Internet Banking or HSBC Mexico.`}
      </Paragraph>
    </Section>
    {isButtonVisible(ismobile) &&
      <Section>
        <Button elementType="a" href={environment.gspContactDetailsUrl} target="_self">{NLS`Return to My accounts`}</Button>
      </Section>
    }
  </FormLayout>
);

ErrorPage.propTypes = {
  ismobile: PropTypes.string,
};

export default withTrackPage('errorPage', 'component')(ErrorPage);
